module.exports = __webpack_public_path__ + "static/media/right-arrow-grey.e883e7ff.svg";